import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router';
import { toast } from 'react-toastify';

import { stripePromise } from '../../utils/common'
import { getCheckoutSession } from '../../utils/Checkout'
import history from '../../../history';

function CheckoutExpress(){
    const params = useParams();
    useEffect(() => {
        (async() => {
            const { sessionId } = params
            
            const { response, error } = await getCheckoutSession(sessionId);

            if(error){
                console.log(error)
                toast.error("Session has expired", {containerId: "defaultToastContainer"})
                history.push("/overview")
            } else {

                
                const stripe = await stripePromise;
                const { error } = await stripe.redirectToCheckout({
                    sessionId: response.sessionId
                });
            }
        })()
    }, [])

    return <>
        <h1 className="page-header">Redirecting. Please wait...</h1>

        <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
    </>
}

export default CheckoutExpress